// @ts-check
import { z } from 'zod';

import Permission from '@/store/modules/models/global/Permission';
import SharingSummary from '@/store/modules/users/models/SharingSummary';

const Sharing = SharingSummary.extend({
  everyone_permission: Permission.nullable(),
});

export default Sharing;

export const SharingUpdate = z
  .object({
    everyone_permission_id: z.number().nullable(),
    groups: z
      .object({ permission_id: z.number(), group_id: z.number() })
      .array(),
    users: z.object({ permission_id: z.number(), user_id: z.number() }).array(),
  })
  .refine(
    val =>
      val.groups.length || val.users.length || val.everyone_permission_id,
    {
      path: ['sharing'],
      message: 'ui.envelopes.create.validation.sharingRequired',
    },
  );

/** @typedef {import('zod').infer<typeof Sharing>} TSharing */
/** @typedef {import('zod').infer<typeof SharingUpdate>} TSharingUpdate */
